export enum ExtensionType {
    Default,
    TaxPayer,
    Intermediary,
    AffectedPerson,
    UnspecifiedParty,
    AssociateEnterprise,
}
